import Helper from "@ember/component/helper";
import { htmlSafe } from "@ember/template";
import BioExamObservation from "core/models/loinc";
import { compute as bioExamDefaultUnitCompute } from "./bio-exam-observation-unit";
export default class BioExamResultsBioExamLabelField extends Helper {
  compute([bioExamObservation]) {
    const unit = bioExamDefaultUnitCompute([bioExamObservation]);
    const name = bioExamObservation.displayLabel;
    const loinc = bioExamObservation.loinc;
    if (loinc == "11475-1") {
      return "Si pertinent, précisez le germe :";
    }
    if (loinc == "94505-5") {
      return "Si pertinent, précisez l'index d'anticorps :";
    }
    return unit ? htmlSafe(`${name}&nbsp;(${unit})`) : htmlSafe(name);
  }
}